import { Button, DatePicker, Input, notification, Table, Checkbox, Card, Tag, Radio } from "antd";
import {
  DownloadOutlined,
  FolderOpenOutlined,
  MailOutlined,
  FilterOutlined,
  WalletOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import React, { Component, Fragment } from "react";
import { withRouter } from "react-router";
import { alertError } from "../../utils/alert";
import { connect } from "react-redux";
import moment from "moment";
import {
  userReportApi,
  userRechargeCollectionReportApi,
} from "../../Graphs/Report/userReportApi";
import {
  exportUserCardBuyReportAPI,
  exportUserRechargeCollectionReportAPI,
} from "../../Graphs/Report/exportJobsAPI";
import ExportJobsDrawer from "./ExportJobsDrawer";
import { dateFormat, dateTimeMoment, formatePrice } from "../../utils/general";
import "./UserReport.scss";

const { RangePicker } = DatePicker;

export class UserReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "transactions",

      // Shared filter criteria
      startDate: null,
      endDate: null,
      searchEmail: "",
      isAllTime: false,
      isDrawerOpen: false,

      // Tab 1: User Transactions
      data: [],
      total: 0,
      isLoading: false,
      isExporting: false,
      showTable: false,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },

      // Tab 2: Recharges & Collections
      rcData: [],
      rcTotal: 0,
      rcSummary: {
        total_recharged: 0,
        total_collected: 0,
        total_deducted: 0,
        net_balance: 0,
      },
      rcLoading: false,
      rcExporting: false,
      rcShowTable: false,
      rcStartIndex: 0,
      rcLimitNumber: 10,
      rcPagination: {
        pageSize: 10,
        current: 1,
      },
    };

    this.getInventoryList = this.getInventoryList.bind(this);
    this.getRechargeCollectionList = this.getRechargeCollectionList.bind(this);
  }

  async componentDidMount() {
    if (this.props.setRouteName) {
      this.props.setRouteName("REPORT");
    }
  }

  handleAllTimeToggle = (e) => {
    const isAllTime = e.target.checked;
    this.setState({
      isAllTime,
    });
  };

  onChangeDate = (date) => {
    if (!date || date.length === 0) {
      this.setState({
        startDate: null,
        endDate: null,
      });
      return;
    }
    this.setState({
      startDate: date[0]?.format("YYYY-MM-DD"),
      endDate: date[1]?.format("YYYY-MM-DD"),
    });
  };

  handelSearchEmail = (event) => {
    const searchEmail = event?.target?.value;
    this.setState({ searchEmail });
  };

  handleTabChange = (activeTab) => {
    this.setState({ activeTab }, () => {
      const { searchEmail, startDate, endDate, isAllTime } = this.state;
      const trimmedEmail = (searchEmail || "").trim();
      const hasFilter = trimmedEmail && (isAllTime || (startDate && endDate));

      if (hasFilter) {
        if (activeTab === "transactions" && !this.state.showTable) {
          this.getInventoryList();
        } else if (activeTab === "recharges_collections" && !this.state.rcShowTable) {
          this.getRechargeCollectionList();
        }
      }
    });
  };

  handleFilter = () => {
    const { activeTab } = this.state;
    if (activeTab === "recharges_collections") {
      this.tempRcCounter = 0;
      this.setState(
        {
          rcStartIndex: 0,
          rcPagination: {
            ...this.state.rcPagination,
            current: 1,
          },
        },
        () => this.getRechargeCollectionList()
      );
    } else {
      this.tempCounter = 0;
      this.setState(
        {
          startIndex: 0,
          pagination: {
            ...this.state.pagination,
            current: 1,
          },
        },
        () => this.getInventoryList()
      );
    }
  };

  // ----------------------------------------------------
  // Tab 1: User Transactions
  // ----------------------------------------------------
  counter = 0;
  tempCounter = 0;

  async getInventoryList() {
    try {
      this.setState({
        isLoading: true,
        showTable: true,
        data: [],
        total: 0,
      });
      const { authToken, loginUserData, history } = this.props;
      let city = loginUserData.role === "Sub_admin" ? loginUserData.city : "";

      const body = {
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        email: (this.state.searchEmail || "").trim(),
        city: city,
        startIndex: this.state.startIndex || 0,
        limitNumber: this.state.limitNumber || 10,
      };

      let inventoryListData = await userReportApi(authToken, body);

      if (inventoryListData.status === 200) {
        const total = inventoryListData?.total || 0;
        this.setState({
          data: Array.isArray(inventoryListData?.data)
            ? inventoryListData.data
            : [],
          total: total,
          pagination: {
            ...this.state.pagination,
            total: total,
          },
        });
      } else if (inventoryListData.status === 401) {
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        notification["error"]({
          message: "Error",
          description: inventoryListData.message,
        });
        this.setState({
          data: [],
          total: 0,
        });
      }
    } catch (e) {
      alertError("REPORT", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  handleTableChange = (pagination) => {
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const limitNumber = pagination.pageSize;
    this.tempCounter = startIndex;
    this.setState(
      {
        pagination: {
          ...this.state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        startIndex,
        limitNumber,
      },
      () => this.getInventoryList()
    );
  };

  columns = [
    {
      title: "Sr. No.",
      key: "Sr_No",
      width: 70,
      render: (text, item, index) => (
        <span>{index + 1 + (this.tempCounter || 0)}</span>
      ),
    },
    {
      title: "Date & Time",
      key: "createdAt",
      width: 160,
      render: (text, item) => (
        <span>{item.createdAt ? dateTimeMoment(item.createdAt) : "-"}</span>
      ),
    },
    {
      title: "Category",
      key: "category",
      width: 170,
      render: (text, item) => {
        const map = {
          ELECTRICITY_BUY: {
            color: "blue",
            text: item.category_label || "Electricity Purchase",
          },
          ELECTRICITY_REFUND: {
            color: "purple",
            text: item.category_label || "Electricity Refund",
          },
          CARD_BUY: {
            color: "blue",
            text: item.category_label || "Card Purchase",
          },
          TRANSFER_SENT: {
            color: "purple",
            text: item.category_label || "Transfer Sent",
          },
          TRANSFER_RECEIVED: {
            color: "cyan",
            text: item.category_label || "Transfer Received",
          },
          SALES_RECHARGE: {
            color: "green",
            text: item.category_label || "Recharge by Salesman",
          },
          BALANCE_REQUEST: {
            color: "orange",
            text: item.category_label || "Recharge by Request",
          },
          WALLET_TRANSFER: {
            color: "gold",
            text: item.category_label || "Wallet Transfer",
          },
          ADMIN_RECHARGE: {
            color: "geekblue",
            text: item.category_label || "Recharge by Admin",
          },
          ADMIN_DEDUCTION: {
            color: "magenta",
            text: item.category_label || "Deduction by Admin",
          },
          ADMIN_ADJUSTMENT: {
            color: "geekblue",
            text: item.category_label || "Admin Adjustment",
          },
        };
        const config = map[item.category] || {
          color: "default",
          text: item.category_label || item.category || "Transaction",
        };
        return <Tag color={config.color}>{config.text}</Tag>;
      },
    },
    {
      title: "Type",
      key: "type",
      width: 110,
      render: (text, item) => {
        const isCredit = item.type === "CREDIT";
        return (
          <Tag color={isCredit ? "green" : "red"}>
            {isCredit ? "CREDIT (+)" : "DEBIT (-)"}
          </Tag>
        );
      },
    },
    {
      title: "Amount (LYD)",
      key: "amount",
      width: 130,
      render: (text, item) => {
        const isCredit = item.type === "CREDIT";
        return (
          <span
            style={{
              fontWeight: 500,
              color: isCredit ? "#16A34A" : "#DC2626",
            }}
          >
            {isCredit ? "+ " : "- "}
            {formatePrice(item.amount)}
          </span>
        );
      },
    },
    {
      title: "Details / Item",
      key: "details",
      render: (text, item) => {
        const isElectricity = item.category && item.category.startsWith("ELECTRICITY");
        return (
          <div>
            <div style={{ fontWeight: 500, color: "#0f172a" }}>
              {item.name || "-"}
            </div>
            {item.serial_number && item.serial_number !== "-" && (
              <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>
                {isElectricity ? "Meter: " : "SN: "}
                <code
                  style={{
                    background: "#f1f5f9",
                    padding: "1px 4px",
                    borderRadius: 3,
                  }}
                >
                  {item.serial_number}
                </code>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Redeem Code",
      key: "redeem_code",
      width: 180,
      render: (text, item) => {
        return item.redeem_code && item.redeem_code !== "-" ? (
          <code
            style={{
              fontSize: 11,
              background: "#f1f5f9",
              padding: "2px 6px",
              borderRadius: "4px",
              fontFamily: "monospace",
            }}
          >
            {item.redeem_code}
          </code>
        ) : (
          <span style={{ color: "#94a3b8" }}>-</span>
        );
      },
    },
    {
      title: "Counterparty / Actor",
      key: "counterparty",
      width: 180,
      render: (text, item) => (
        <span style={{ fontSize: 13, color: "#334155" }}>
          {item.counterparty && item.counterparty !== "-"
            ? item.counterparty
            : "-"}
        </span>
      ),
    },
    {
      title: "City",
      key: "city",
      width: 100,
      render: (text, item) => <span>{item.city || "-"}</span>,
    },
  ];

  generateCsv = async () => {
    try {
      const { startDate, endDate, searchEmail, isAllTime } = this.state;
      const { authToken, loginUserData } = this.props;
      const trimmedEmail = (searchEmail || "").trim();

      if (!trimmedEmail) {
        notification.warning({
          message: "Email Required",
          description: "Please enter a user email to export transaction records.",
        });
        return;
      }

      this.setState({ isExporting: true });

      const city = loginUserData.role === "Sub_admin" ? loginUserData.city : "";
      const body = {
        email: trimmedEmail,
        start_date: isAllTime ? null : startDate,
        end_date: isAllTime ? null : endDate,
        city: city,
      };

      const result = await exportUserCardBuyReportAPI(authToken, body);

      if (result && result.is_stream) {
        notification.success({
          message: "Export Complete",
          description: "Your report CSV has been downloaded successfully.",
        });
      } else if (result && result.status === 202) {
        notification.info({
          message: "All-Time Export Queued",
          description:
            "Your export job is compiling in the background. You can track its progress in the Downloads drawer.",
        });
        this.setState({ isDrawerOpen: true });
      } else if (result && result.message) {
        notification.error({
          message: "Export Error",
          description: result.message,
        });
      }
    } catch (e) {
      alertError("REPORT", e);
    } finally {
      this.setState({ isExporting: false });
    }
  };

  // ----------------------------------------------------
  // Tab 2: Recharges & Collections
  // ----------------------------------------------------
  tempRcCounter = 0;

  async getRechargeCollectionList() {
    try {
      this.setState({
        rcLoading: true,
        rcShowTable: true,
        rcData: [],
        rcTotal: 0,
      });
      const { authToken, loginUserData, history } = this.props;
      let city = loginUserData.role === "Sub_admin" ? loginUserData.city : "";

      const body = {
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        email: (this.state.searchEmail || "").trim(),
        city: city,
        startIndex: this.state.rcStartIndex || 0,
        limitNumber: this.state.rcLimitNumber || 10,
      };

      let resData = await userRechargeCollectionReportApi(authToken, body);

      if (resData.status === 200) {
        const total = resData?.total || 0;
        const summary = resData?.summary || {
          total_recharged: 0,
          total_collected: 0,
          total_deducted: 0,
          net_balance: 0,
        };
        this.setState({
          rcData: Array.isArray(resData?.data) ? resData.data : [],
          rcTotal: total,
          rcSummary: summary,
          rcPagination: {
            ...this.state.rcPagination,
            total: total,
          },
        });
      } else if (resData.status === 401) {
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        notification["error"]({
          message: "Error",
          description: resData.message,
        });
        this.setState({
          rcData: [],
          rcTotal: 0,
        });
      }
    } catch (e) {
      alertError("REPORT", e);
    } finally {
      this.setState({
        rcLoading: false,
      });
    }
  }

  handleRcTableChange = (pagination) => {
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const limitNumber = pagination.pageSize;
    this.tempRcCounter = startIndex;
    this.setState(
      {
        rcPagination: {
          ...this.state.rcPagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        rcStartIndex: startIndex,
        rcLimitNumber: limitNumber,
      },
      () => this.getRechargeCollectionList()
    );
  };

  rcColumns = [
    {
      title: "Sr. No.",
      key: "Sr_No",
      width: 70,
      render: (text, item, index) => (
        <span>{index + 1 + (this.tempRcCounter || 0)}</span>
      ),
    },
    {
      title: "Transaction ID",
      key: "id",
      width: 140,
      render: (text, item) => (
        <code
          style={{
            fontSize: 11,
            background: "#f8fafc",
            padding: "2px 6px",
            borderRadius: 4,
            fontFamily: "monospace",
          }}
        >
          {item.id}
        </code>
      ),
    },
    {
      title: "Date & Time",
      key: "createdAt",
      width: 160,
      render: (text, item) => (
        <span>{item.createdAt ? dateTimeMoment(item.createdAt) : "-"}</span>
      ),
    },
    {
      title: "Event Type",
      key: "event_type",
      width: 180,
      render: (text, item) => {
        const tagMap = {
          "Recharge by Salesman": { color: "green" },
          "Balance Collection": { color: "gold" },
          "Recharge by Request": { color: "orange" },
          "Recharge by Admin": { color: "geekblue" },
          "Deduction by Admin": { color: "magenta" },
        };
        const conf = tagMap[item.event_type] || { color: "default" };
        return <Tag color={conf.color}>{item.event_type}</Tag>;
      },
    },
    {
      title: "Type",
      key: "type",
      width: 110,
      render: (text, item) => {
        const isCredit = item.type === "CREDIT";
        return (
          <Tag color={isCredit ? "green" : "red"}>
            {isCredit ? "CREDIT (+)" : "DEBIT (-)"}
          </Tag>
        );
      },
    },
    {
      title: "Amount (LYD)",
      key: "amount",
      width: 130,
      render: (text, item) => {
        const isCredit = item.type === "CREDIT";
        return (
          <span
            style={{
              fontWeight: 600,
              color: isCredit ? "#16A34A" : "#DC2626",
            }}
          >
            {isCredit ? "+ " : "- "}
            {formatePrice(item.amount)}
          </span>
        );
      },
    },
    {
      title: "Actor / Handled By",
      key: "actor",
      width: 200,
      render: (text, item) => (
        <span style={{ fontWeight: 500, color: "#1e293b", fontSize: 13 }}>
          {item.actor || "-"}
        </span>
      ),
    },
    {
      title: "Reference / Notes",
      key: "notes",
      render: (text, item) => (
        <span style={{ color: "#64748b", fontSize: 13 }}>
          {item.notes || "-"}
        </span>
      ),
    },
    {
      title: "City",
      key: "city",
      width: 100,
      render: (text, item) => <span>{item.city || "-"}</span>,
    },
  ];

  generateRcCsv = async () => {
    try {
      const { startDate, endDate, searchEmail, isAllTime } = this.state;
      const { authToken, loginUserData } = this.props;
      const trimmedEmail = (searchEmail || "").trim();

      if (!trimmedEmail) {
        notification.warning({
          message: "Email Required",
          description:
            "Please enter a user email to export recharge and collection records.",
        });
        return;
      }

      this.setState({ rcExporting: true });

      const city = loginUserData.role === "Sub_admin" ? loginUserData.city : "";
      const body = {
        email: trimmedEmail,
        start_date: isAllTime ? null : startDate,
        end_date: isAllTime ? null : endDate,
        city: city,
      };

      const result = await exportUserRechargeCollectionReportAPI(
        authToken,
        body
      );

      if (result && result.is_stream) {
        notification.success({
          message: "Export Complete",
          description:
            "Your recharge and collection report CSV has been downloaded successfully.",
        });
      } else if (result && result.status === 202) {
        notification.info({
          message: "All-Time Export Queued",
          description:
            "Your recharge & collection export job is compiling in the background. You can track its progress in the Downloads drawer.",
        });
        this.setState({ isDrawerOpen: true });
      } else if (result && result.message) {
        notification.error({
          message: "Export Error",
          description: result.message,
        });
      }
    } catch (e) {
      alertError("REPORT", e);
    } finally {
      this.setState({ rcExporting: false });
    }
  };

  render() {
    const { loginUserData } = this.props;
    let accessPermission = false;
    if (loginUserData?.access_permission) {
      if (typeof loginUserData.access_permission === "string") {
        try {
          accessPermission = JSON.parse(loginUserData.access_permission);
        } catch (e) {
          accessPermission = false;
        }
      } else {
        accessPermission = loginUserData.access_permission;
      }
    }

    const isAuthorized =
      !loginUserData ||
      loginUserData.role === "Admin" ||
      loginUserData.role === "Sub_admin" ||
      Boolean(
        accessPermission &&
          (accessPermission.reports?.view ||
            accessPermission.dashboard?.view ||
            accessPermission.userReports?.view ||
            accessPermission.userCardBuyReport?.view)
      );

    if (!isAuthorized) {
      return (
        <Fragment>
          <h5 style={{ marginTop: "30%", marginLeft: "30%" }}>
            You are not authorized for view this page.
          </h5>
        </Fragment>
      );
    }

    const {
      activeTab,
      isAllTime,
      isExporting,
      isLoading,
      rcLoading,
      rcExporting,
      searchEmail,
      startDate,
      endDate,
      showTable,
      rcShowTable,
      data,
      rcData,
      rcSummary,
      isDrawerOpen,
    } = this.state;

    const trimmedEmail = (searchEmail || "").trim();
    const canExport = Boolean(
      trimmedEmail && (isAllTime || (startDate && endDate))
    );
    const isCurrentLoading =
      activeTab === "recharges_collections" ? rcLoading : isLoading;
    const isCurrentExporting =
      activeTab === "recharges_collections" ? rcExporting : isExporting;

    return (
      <Fragment>
        <div className="daily-audit-page user-reports-page">
          {/* Header */}
          <div className="daily-audit-page-heading">
            <div>
              <h3 className="daily-audit-title">User Reports</h3>
            </div>
            <div className="daily-audit-heading-actions">
              <Radio.Group
                className="user-report-type-switch settlement-period-switch"
                value={activeTab}
                onChange={(e) => this.handleTabChange(e.target.value)}
                buttonStyle="solid"
              >
                <Radio.Button value="transactions">Transactions</Radio.Button>
                <Radio.Button value="recharges_collections">
                  Recharges & Collections
                </Radio.Button>
              </Radio.Group>
              <Button
                icon={<FolderOpenOutlined />}
                onClick={() => this.setState({ isDrawerOpen: true })}
              >
                Downloads
              </Button>
            </div>
          </div>

          <Card bordered={false} className="daily-audit-report-card">
            {/* Top Filter Bar */}
            <div className="daily-audit-tab-toolbar">
              <div className="toolbar-left">
                <Input
                  prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
                  type="email"
                  value={searchEmail}
                  placeholder="Enter User Email"
                  style={{ width: 280 }}
                  onChange={this.handelSearchEmail}
                  onPressEnter={() => {
                    if (
                      !isAllTime &&
                      startDate &&
                      endDate &&
                      trimmedEmail &&
                      !isCurrentLoading
                    ) {
                      this.handleFilter();
                    }
                  }}
                  allowClear
                />
                <RangePicker
                  format="YYYY-MM-DD"
                  value={
                    startDate && endDate
                      ? [
                          moment(startDate, "YYYY-MM-DD"),
                          moment(endDate, "YYYY-MM-DD"),
                        ]
                      : null
                  }
                  onChange={this.onChangeDate}
                  disabled={isAllTime}
                  disabledDate={(current) =>
                    current && current > moment().endOf("day")
                  }
                />
                <Checkbox
                  checked={isAllTime}
                  onChange={this.handleAllTimeToggle}
                >
                  All Time History
                </Checkbox>
                {!isAllTime && (
                  <Button
                    type="primary"
                    icon={<FilterOutlined />}
                    onClick={this.handleFilter}
                    disabled={
                      isCurrentLoading ||
                      !(startDate && endDate && trimmedEmail)
                    }
                  >
                    Filter
                  </Button>
                )}
              </div>

              <div className="toolbar-right">
                <Button
                  style={{
                    background: "#5C6AC4",
                    borderColor: "#5C6AC4",
                    color: "#fff",
                  }}
                  icon={<DownloadOutlined />}
                  loading={isCurrentExporting}
                  disabled={!canExport || isCurrentExporting}
                  onClick={
                    activeTab === "recharges_collections"
                      ? this.generateRcCsv
                      : this.generateCsv
                  }
                >
                  {isAllTime ? "Export All-Time (CSV)" : "Generate CSV"}
                </Button>
              </div>
            </div>

            {isAllTime && (
              <div
                style={{
                  padding: "14px 18px",
                  background: "#f8fafc",
                  borderRadius: "6px",
                  border: "1px solid #e2e8f0",
                  margin: "16px 0",
                  color: "#475569",
                  fontSize: 13,
                }}
              >
                All-time transaction and collection history can contain
                thousands of records and is compiled directly into a
                downloadable CSV export. Click{" "}
                <strong>Export All-Time (CSV)</strong> above to queue and
                download the complete report.
              </div>
            )}

            {/* Content Section */}
            {activeTab === "transactions" ? (
              showTable && !isAllTime && (
                <div style={{ overflowX: "auto", marginTop: 12 }}>
                  <Table
                    className="daily-audit-table"
                    loading={isLoading}
                    rowKey={(record) => record.id}
                    columns={this.columns}
                    size="middle"
                    scroll={{ x: 1260 }}
                    dataSource={data}
                    pagination={{
                      ...this.state.pagination,
                      total: this.state.total,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "25", "50", "100", "250"],
                      showTotal: (total, range) =>
                        `Showing ${range[0]}-${range[1]} of ${total} transactions`,
                    }}
                    onChange={this.handleTableChange}
                    bordered={false}
                    locale={{
                      emptyText: (
                        <div className="daily-audit-empty-state">
                          <strong>No user transaction records found</strong>
                          <span>
                            Enter a user email and select a date range (or
                            All-Time) to view card purchases and transfers.
                          </span>
                        </div>
                      ),
                    }}
                  />
                </div>
              )
            ) : (
              rcShowTable && !isAllTime && (
                <div style={{ marginTop: 16 }}>
                  {/* Summary KPI Cards */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(220px, 1fr))",
                      gap: 16,
                      marginBottom: 20,
                    }}
                  >
                    <Card
                      size="small"
                      style={{
                        borderRadius: 8,
                        borderLeft: "4px solid #16a34a",
                        background: "#f0fdf4",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          color: "#15803d",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        Total Recharged
                      </div>
                      <div
                        style={{
                          fontSize: 22,
                          fontWeight: 700,
                          color: "#166534",
                          marginTop: 4,
                        }}
                      >
                        + {formatePrice(rcSummary.total_recharged || 0)} LYD
                      </div>
                      <div
                        style={{ fontSize: 11, color: "#15803d", marginTop: 2 }}
                      >
                        Salesman recharges, balance requests & admin credits
                      </div>
                    </Card>

                    <Card
                      size="small"
                      style={{
                        borderRadius: 8,
                        borderLeft: "4px solid #d97706",
                        background: "#fffbeb",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          color: "#b45309",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        Total Balance Collected
                      </div>
                      <div
                        style={{
                          fontSize: 22,
                          fontWeight: 700,
                          color: "#92400e",
                          marginTop: 4,
                        }}
                      >
                        - {formatePrice(rcSummary.total_collected || 0)} LYD
                      </div>
                      <div
                        style={{ fontSize: 11, color: "#b45309", marginTop: 2 }}
                      >
                        Cash collected from user by salesmen
                      </div>
                    </Card>

                    <Card
                      size="small"
                      style={{
                        borderRadius: 8,
                        borderLeft: `4px solid ${
                          (rcSummary.net_balance || 0) >= 0
                            ? "#2563eb"
                            : "#dc2626"
                        }`,
                        background:
                          (rcSummary.net_balance || 0) >= 0
                            ? "#eff6ff"
                            : "#fef2f2",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          color:
                            (rcSummary.net_balance || 0) >= 0
                              ? "#1d4ed8"
                              : "#b91c1c",
                          fontWeight: 600,
                          textTransform: "uppercase",
                        }}
                      >
                        Net Balance Change
                      </div>
                      <div
                        style={{
                          fontSize: 22,
                          fontWeight: 700,
                          color:
                            (rcSummary.net_balance || 0) >= 0
                              ? "#1e40af"
                              : "#dc2626",
                          marginTop: 4,
                        }}
                      >
                        {(rcSummary.net_balance || 0) >= 0 ? "+ " : "- "}
                        {formatePrice(
                          Math.abs(rcSummary.net_balance || 0)
                        )}{" "}
                        LYD
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color:
                            (rcSummary.net_balance || 0) >= 0
                              ? "#1d4ed8"
                              : "#b91c1c",
                          marginTop: 2,
                        }}
                      >
                        Recharges minus balance collections and deductions
                      </div>
                    </Card>
                  </div>

                  {/* Table */}
                  <div style={{ overflowX: "auto" }}>
                    <Table
                      className="daily-audit-table"
                      loading={rcLoading}
                      rowKey={(record) => record.id}
                      columns={this.rcColumns}
                      size="middle"
                      scroll={{ x: 1260 }}
                      dataSource={rcData}
                      pagination={{
                        ...this.state.rcPagination,
                        total: this.state.rcTotal,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "25", "50", "100", "250"],
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} records`,
                      }}
                      onChange={this.handleRcTableChange}
                      bordered={false}
                      locale={{
                        emptyText: (
                          <div className="daily-audit-empty-state">
                            <strong>
                              No recharge or collection records found
                            </strong>
                            <span>
                              Enter a user email and select a date range (or
                              All-Time) to view salesman recharges and cash
                              collections.
                            </span>
                          </div>
                        ),
                      }}
                    />
                  </div>
                </div>
              )
            )}
          </Card>
        </div>

        <ExportJobsDrawer
          visible={isDrawerOpen}
          onClose={() => this.setState({ isDrawerOpen: false })}
          authToken={this.props.authToken}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

const mapDispatchToProps = (dispatch) => ({
  setRouteName: (routeName) => {
    dispatch({
      type: "SET_ROUTE_NAME",
      routeName: routeName,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserReport));
